module.exports = __webpack_public_path__ + "assets/faff92145777a3cbaf8e7367b4807987.woff";


//////////////////
// WEBPACK FOOTER
// ./webpack/assets/semantic/themes/default/assets/fonts/icons.woff
// module id = 3652
// module chunks = 0